import { Button } from "@/components/ui/button";
import { useForm } from "@tanstack/react-form";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/lab/buttons")({
  component: RouteComponent,
});

function RouteComponent() {
  const intents = [
    "link",
    "soft",
    "solid",
    "ghost",
    "outline",
    "plain",
  ] as const;
  const flavors = ["accent", "gray", "destructive"] as const;
  const alphas = [true, false] as const;

  useForm;

  return (
    <div className="container mx-auto">
      <div className="grid grid-cols-2 gap-8">
        {intents.map((intent) => (
          <div key={intent} className="grid grid-cols-3 gap-4 p-2 border">
            {flavors.map((flavor) => (
              <div key={flavor} className="grid grid-cols-1 gap-2">
                {alphas.map((alpha) => (
                  <Button
                    key={String(alpha)}
                    intent={intent}
                    flavor={flavor}
                    alpha={alpha}
                  >
                    {intent.toUpperCase()} {flavor} {alpha ? "[A]" : ""}
                  </Button>
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
